import { useContext, useEffect } from 'react';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import PokeContext from '../../context';

export default function PokeDetail() {
	const { id } = useParams();
    const { getPokemonDetail, pokemons, isLoading, hasError } = useContext(PokeContext);

    useEffect(() => {
       getPokemonDetail(id);
    }, []);

    console.log(isLoading);

    if(isLoading){
        return (<div>Cargando pokemon</div>);
    }

	return (
		<div className="container pokemon-container">
			{hasError ? (
				<div>Error al carga al pokemon</div>
			) : (
				<>
					<div className="pokemon-titulo">
						<h2 style={{ textTransform: 'capitalize', textAlign: 'center' }}>
							{id}
						</h2>
					</div>
					<div style={{ height: 200, textAlign: 'center' }}>
						<img
							src={pokemons[0].sprites.front_default}
							style={{ height: 200 }}
							alt="img-detalle"
						/>
					</div>
					<div className="pokemon-detail" >
						<div style={{ display: 'flex', justifyContent: 'space-between' }}>
							<p>Peso:</p>
							<p>{pokemons[0].weight}</p>
						</div>
						<div style={{ display: 'flex', justifyContent: 'space-between' }}>
							<p>Altura: </p>
							<p>{pokemons[0].height}</p>
						</div>
						<div>
							Tipo:
							{pokemons[0].types.map((type, idx) => {
								return (
									<div
										key={idx}
										className={`pokemon-type-text ${
											idx === 1 ? 'color-a' : 'color-b'
										}`}
										style={{ marginBottom: 10, textAlign: 'center' }}
									>
										{type.type.name}
									</div>
								);
							})}
						</div>
						<div>
							<h3>Hablidades</h3>
							<div>
								{pokemons[0]?.stats.map(
									({ stat, base_stat }, index) => {
										return (
											<div
												key={index}
												style={{
													marginBottom: 20,
													display: 'flex',
													justifyContent: 'space-between',
												}}
											>
												<p>{stat.name} :</p>
												<p>{`${base_stat}`}</p>
											</div>
										);
									}
								)}
							</div>
						</div>
						<div style={{ textAlign: 'center' }}>
							<Link to="/" className="btn-back">Regresar</Link>
						</div>
					</div>
					
				</>
			)}
		</div>
	);
}
